import { Box } from "@mui/material";
import { useRestaurantData } from "../../provider/RestaurantDataContext";
import CustomTitleBox from "../centralComponents/CustomTitleBox";
import { useTranslation } from "react-i18next";


export default function AboutUs() {
    const { t } = useTranslation();
    const { restaurantData: { qrMenuProperties } } = useRestaurantData();

    return (
        <CustomTitleBox title={t('aboutUs')}>
            <Box style={{ color: 'white', marginRight: '0.5rem', marginLeft: '0.5rem', paddingBottom: '1rem' }}
                dangerouslySetInnerHTML={{ __html: qrMenuProperties?.value }}
            />
        </CustomTitleBox>
    );
}